import { render, staticRenderFns } from "./AdminProviderBadge.vue?vue&type=template&id=358dee8f&"
import script from "./AdminProviderBadge.vue?vue&type=script&lang=ts&"
export * from "./AdminProviderBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports